import axios from "axios";
import {
  GET_ADMINS,
  GET_ADMINS_ERROR,
  ADMINS_LOADING,
  SAVE_ADMIN,
  DELETE_ADMIN,
  SAVE_ROLE,
  DELETE_ROLE,
} from "./types";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";
import { mailToast } from "../utils/mailToast";

// The users of this app (Admin records) and their roles, behind /api/admin

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch) => {
  // No response: the network or the server is down
  if (!err.response) {
    toastr.error("Сервертэй холбогдож чадсангүй");
    return;
  }
  if (
    err.response.status === 401 &&
    err.response.data.msg === "Token is not valid"
  ) {
    window.localStorage.clear("x-auth-token");
    toastr.error("Session expired");
    dispatch(logout());
  }
  const errors = err.response.data.errors;
  if (errors) {
    errors.forEach((error) => toastr.error(error.msg));
  }
};

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

//  Every admin, the roles one can be given with what each opens, and the keys
//  a role can be given
export const getAdmins = () => async (dispatch) => {
  try {
    dispatch({ type: ADMINS_LOADING });
    const res = await axios.get("/api/admin");
    dispatch({
      type: GET_ADMINS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({ type: GET_ADMINS_ERROR });
    handleError(err, dispatch);
  }
};

//  Creates (no id) or saves an admin. No one sets another's password: a new
//  admin is mailed an invite to set their own. Returns { admin } or the
//  backend's { errors }, for the form to show.
export const saveAdmin = (id, body) => async (dispatch) => {
  try {
    const res = id
      ? await axios.put(`/api/admin/${id}`, JSON.stringify(body), config)
      : await axios.post("/api/admin", JSON.stringify(body), config);
    const { mailed, ...admin } = res.data;
    dispatch({
      type: SAVE_ADMIN,
      payload: admin,
    });
    if (id) toastr.success("Хадгалагдлаа");
    else mailToast(admin.email, "урилга", mailed);
    return { admin };
  } catch (err) {
    if (!err.response || !err.response.data.errors) handleError(err, dispatch);
    return {
      errors: (err.response && err.response.data.errors) || [],
    };
  }
};

//  Mails the admin a new link to set their password: their invite again while
//  they have not set one, otherwise a reset. A link sent before stops working,
//  and the password they have keeps working until they set a new one.
export const sendPasswordLink = (id) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/admin/${id}/password-link`);
    mailToast(
      res.data.email,
      res.data.pending ? "урилга" : "нууц үг сэргээх холбоос",
      res.data.mailed
    );
    return true;
  } catch (err) {
    handleError(err, dispatch);
    return false;
  }
};

//  The backend refuses to delete the signed-in admin
export const deleteAdmin = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/admin/${id}`);
    dispatch({
      type: DELETE_ADMIN,
      payload: id,
    });
    toastr.success("Устгагдлаа");
    return true;
  } catch (err) {
    handleError(err, dispatch);
    return false;
  }
};

//  Adds (no key) or saves a role; its admins get the change on their next
//  request. Returns { role } or the backend's { errors }, for the form to show.
export const saveRole = (key, body) => async (dispatch) => {
  try {
    const res = key
      ? await axios.put(`/api/admin/roles/${key}`, JSON.stringify(body), config)
      : await axios.post("/api/admin/roles", JSON.stringify(body), config);
    dispatch({
      type: SAVE_ROLE,
      payload: res.data,
    });
    toastr.success("Хадгалагдлаа");
    return { role: res.data };
  } catch (err) {
    if (!err.response || !err.response.data.errors) handleError(err, dispatch);
    return {
      errors: (err.response && err.response.data.errors) || [],
    };
  }
};

//  The backend refuses to delete full, one's own role, or a role an admin has
export const deleteRole = (key) => async (dispatch) => {
  try {
    await axios.delete(`/api/admin/roles/${key}`);
    dispatch({
      type: DELETE_ROLE,
      payload: key,
    });
    toastr.success("Устгагдлаа");
    return true;
  } catch (err) {
    handleError(err, dispatch);
    return false;
  }
};
